module.exports = __webpack_public_path__ + "static/media/RP-53.cc19c26d.pdf";